import { Icons } from 'src/assets/fonts/Icons/icons';
import { formatImagePath } from 'src/utils/formatter';
import { filterInactiveStatuses } from 'src/view/screens/DeliveryManagementScreen/screens/DeliveryTrackingScreen/helpers/deliveryTracking';
import { TClusteringIcon } from 'src/view/screens/DeliveryManagementScreen/screens/DeliveryTrackingScreen/types/deliveryTracking';

export enum DELIVERY_REQUEST_STATUS {
  NO_STATUS = 0,
  PENDING = 11,
  ASSIGNED,
  WAY_TO_STORE,
  ARRIVED_AT_STORE,
  WAY_TO_CUSTOMER,
  NEAR_CUSTOMER,
  NEAR_STORE,
  ARRIVED_AT_CUSTOMER,
  DELIVERED = 21,
  CANCELED = 31,
  RETURNED,
  DSP_ISSUE,
  NOT_SENT,
  RETURNING,
}

// export const REQUESTS_STATUSES_LABELS: { [key in DELIVERY_REQUEST_STATUS]: string } = {
//   0: 'no_status_status',
//   11: 'pending_status',
//   12: 'assigned_status',
//   13: 'way_to_store_status',
//   14: 'arrived_at_store_status',
//   15: 'way_to_customer_status',
//   16: 'near_customer_status',
//   17: 'near_store_status',
//   18: 'arrived_at_customer_status',
//   21: 'delivered_status',
//   31: 'canceled_status',
//   32: 'returned_status',
//   33: 'dsp_issue_status',
//   34: 'not_sent_status',
//   35: 'returning_status',
// };

export enum TRACKING_GROUPS {
  ALL = 'all',
  NEW = 'new',
  IN_DELIVERY = 'in_delivery',
  NEED_ATTENTION = 'attention',
  NEED_ACTION = 'action',
}

export const STATUSES_GROUPS: { [key in TRACKING_GROUPS]: DELIVERY_REQUEST_STATUS[] } = {
  all: filterInactiveStatuses(Object.values(DELIVERY_REQUEST_STATUS) as DELIVERY_REQUEST_STATUS[]),
  new: [DELIVERY_REQUEST_STATUS.NO_STATUS, DELIVERY_REQUEST_STATUS.PENDING, DELIVERY_REQUEST_STATUS.DSP_ISSUE, DELIVERY_REQUEST_STATUS.NOT_SENT],
  in_delivery: [
    DELIVERY_REQUEST_STATUS.ASSIGNED,
    DELIVERY_REQUEST_STATUS.WAY_TO_STORE,
    DELIVERY_REQUEST_STATUS.NEAR_STORE,
    DELIVERY_REQUEST_STATUS.ARRIVED_AT_CUSTOMER,
  ],
  attention: [],
  action: [],
};

export const mapIcons: { [key in TClusteringIcon]: string } = {
  pin: formatImagePath(`${Icons.Pin}.svg`),
  selectedPin: formatImagePath(`${Icons.SelectedPin}.svg`),
  branch: formatImagePath(`${Icons.MapLocation}.svg`),
  selectedBranch: formatImagePath(`${Icons.SelectedMapLocation}.svg`),
};
